module.exports = __webpack_public_path__ + "static/Tancred Yip.ed9f3727.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Tancred Yip.jpg
// module id = 1239
// module chunks = 6166952557895